import { Rss } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { useGetActivityUnreadCountQuery } from '@/redux/activity/activity.api.slice';
import { cn } from '@/lib/utils';
import { setShowFeedSheet } from '@/redux/global/global.slice';

const POLL_MS = 60_000;
// the server caps the count at 100
const CAP = 100;

function UnreadBadge({ className }: { className?: string }) {
  const { data: count = 0 } = useGetActivityUnreadCountQuery(undefined, {
    pollingInterval: POLL_MS,
  });
  if (count === 0) return null;
  return (
    <span
      data-testid="feed-unread-badge"
      className={cn(
        'min-w-[18px] rounded-full bg-red-600 px-1 py-px text-center text-[10px] font-bold leading-[14px] text-white',
        className
      )}
    >
      {count >= CAP ? '99+' : count}
    </span>
  );
}

export function FeedTile({ className }: { className: string }) {
  const dispatch = useDispatch();
  return (
    <button
      type="button"
      aria-label="Feed"
      aria-haspopup="dialog"
      title="Feed"
      className={cn(className, 'relative')}
      onClick={() => dispatch(setShowFeedSheet(true))}
    >
      <Rss className="h-5 w-5" />
      <span className="hidden 2xl:inline">Feed</span>
      <UnreadBadge className="absolute -right-1.5 -top-1.5 z-10" />
    </button>
  );
}

export function FeedRowContent({ tileClassName }: { tileClassName: string }) {
  return (
    <>
      <span className={tileClassName}>
        <Rss className="h-[18px] w-[18px]" />
      </span>
      Feed
      <UnreadBadge className="ml-auto" />
    </>
  );
}
